import { createMmWsAction } from '@skynet/data-ws-mm';
import { createAppAsyncThunk } from 'src/store/utils/thunks';
import { selectCurrentLoan } from 'src/store/loans/selectors';
import { selectCurrentProject } from 'src/store/retainers/selectors';
import { selectArbitrageInfoStatus } from 'src/store/shared/arbitrage-info/selectors';
import { ArbitrageInfoCommands } from './types';
import type { GetArbitrageDataWsPayload } from './types';

export const getArbitrageDataWs = createMmWsAction<
  GetArbitrageDataWsPayload,
  GetArbitrageDataWsPayload
>('loans/getArbitrageDataWs', (data) => ({
  command: ArbitrageInfoCommands.GetArbitrage,
  ...data,
}));

export const getArbitrageData = createAppAsyncThunk('loans/getArbitrageData', (_, thunkApi) => {
  const state = thunkApi.getState();
  const projectID = selectCurrentProject(state)?.id;
  const loanID = selectCurrentLoan(state)?.id;
  const isPending = selectArbitrageInfoStatus(state) === 'pending';
  if (!isPending) {
    thunkApi.dispatch(
      getArbitrageDataWs({ ...(projectID && { projectID }), ...(loanID && { loanID }) }),
    );
  }
});
